<template>
  <div>
    <v-form-input
      id="activity-day-item-resource-supplier-observation"
      v-model:modelValue="supplierObservation"
      :label="$t('general.shared.supplier_observations')"
      input-type="textarea"
      :rows="5"
      class="mb-24"
    />
    <div class="d-flex justify-content-end">
      <v-button :disabled="loading" variant="primary" @click="saveObservation">
        {{ $t('general.button.save') }}
        <v-icon icon="arrow-right" size="sm" space="ms-12" />
      </v-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import api from '@/api';
import VButton from '@/components/vendor/basic/button/VButton.vue';
import VIcon from '@/components/vendor/basic/icon/VIcon.vue';
import { VFormInput } from '@uniqoders/form';

const props = defineProps<{
  agency: string;
  activityId: number;
  activityDayId: number;
  activityDayItemId: number;
  activityDayItemResourceId: number;
  initialObservation?: string;
}>();

const emit = defineEmits<{
  (e: 'emitReload'): void;
}>();

const { t } = useI18n();
const supplierObservation = ref(props.initialObservation || '');
const loading = ref(false);

const saveObservation = async () => {
  loading.value = true;
  try {
    await api.activityService.updateActivityDayItemResource(
      props.agency,
      props.activityId,
      props.activityDayId,
      props.activityDayItemId,
      props.activityDayItemResourceId,
      { supplier_observation: supplierObservation.value }
    );
    emit('emitReload');
  } catch (e: any) {
    // Optionally show error toast
    // $toast.error(e?.response?.data?.message || 'Error updating observation');
    console.error(e);
  } finally {
    loading.value = false;
  }
};
</script> 